import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NotificationContextService {
    notificationSubject = new Subject<void>();
    notificationUpdated$ = this.notificationSubject.asObservable();

    notifyNotificationUpdated(): void {
        this.notificationSubject.next();
    }
}
